import { AppAction, PageFilter } from '../app';
import {
  SampleDevelopmentTlApprovalRequest,
  SampleDevelopmentTlApprovalRequestListFilter,
} from './sampleDevelopmentTlApprovalRequest.types';

export const FETCH_SAMPLE_DEV_TL_APPROVAL_REQUEST_LIST =
  'FETCH_SAMPLE_DEV_TL_APPROVAL_REQUEST_LIST';
export const OPEN_SAMPLE_DEV_TL_APPROVAL_REQUEST_DIALOG =
  'OPEN_SAMPLE_DEV_TL_APPROVAL_REQUEST_DIALOG';

export const CLOSE_SAMPLE_DEV_TL_APPROVAL_REQUEST_DIALOG =
  'CLOSE_SAMPLE_DEV_TL_APPROVAL_REQUEST_DIALOG';

export const UPDATE_SAMPLE_DEV_TL_APPROVAL_REQUEST_RESPONSE =
  'UPDATE_SAMPLE_DEV_TL_APPROVAL_REQUEST_RESPONSE';
export const fetchSampleDevelopmentTlApprovalRequestList = (
  filters: SampleDevelopmentTlApprovalRequestListFilter,
  paging: PageFilter,
): AppAction => {
  return {
    type: FETCH_SAMPLE_DEV_TL_APPROVAL_REQUEST_LIST,
    payload: {
      filters,
      paging,
    },
  };
};

export const updateSampleDevelopmentTlApprovalRequestResponse = (
  payload: SampleDevelopmentTlApprovalRequest,
) => ({
  type: UPDATE_SAMPLE_DEV_TL_APPROVAL_REQUEST_RESPONSE,
  payload,
});

export const openSampleDevelopmentTlApprovalRequestDialog = () => ({
  type: OPEN_SAMPLE_DEV_TL_APPROVAL_REQUEST_DIALOG,
});

export const closeSampleDevelopmentTlApprovalRequestDialog = () => ({
  type: CLOSE_SAMPLE_DEV_TL_APPROVAL_REQUEST_DIALOG,
});
